import { Themes } from '@sainsburys-tech/bolt'
import { ArgosVocab, HabitatVocab } from '@sainsburys-tech/bolt-vocab-provider'

const BOLT_VERSION = '8.0.1'

// This file is used by both the client and the server.
// Do not include API keys or server functions, as these will be included in the client bundle.

export default {
  argos: {
    key: 'argos',
    salesChannel: 'argos',
    canonicalBase: 'https://www.argos.co.uk',
    faviconPath: '/i/Argos/ArgosFavicon',
    tealiumPath: 'argos/main/qa',
    theme: Themes.ArgosTheme,
    vocab: ArgosVocab,
    bolt: {
      url: `https://www.argos.co.uk/assets/bolt2/${BOLT_VERSION}/bolt.min.css`,
      namespace: 'bolt-v2'
    },
    features: {
      taxonomy: {
        vocabId: ''
      },
      addToTrolley: {
        modal: {
          enabled: true,
          hideExtras: false,
          hideCategories: false
        }
      },
      bestSellers: {
        enabled: true
      },
      sponsoredProducts: {
        enabled: true
      },
      wishlist: {
        enabled: true
      },
      productList: {
        forceClothingTemplate: false,
        forceEnableAltImageHover: false,
        disableComRel: false,
        additionalBrandLogos: null,
        enableSortbyNew: false
      },
      productCard: {
        colorSwatchInline: true,
        colorSwatchAlwaysVisible: false,
        colorSwatchMaxVariations: 4,
        colorSwatchSize: 'small'
      },
      listerTools: {
        hideMobileResultsCount: false,
        offsetSelector: null,
        safeZone: 375,
        reverseScrollBehaviour: false
      },
      categoryList: {
        contentAreaNav: true
      },
      availability: {
        enabled: true,
        radius: 10
      }
    }
  },
  habitat: {
    key: 'habitat',
    salesChannel: 'habitat',
    canonicalBase: 'https://www.habitat.co.uk',
    faviconPath: '/i/Argos/HabitatFavicon',
    tealiumPath: 'argos/habitat/qa',
    theme: Themes.HabitatTheme,
    vocab: HabitatVocab,
    bolt: {
      url: `https://www.argos.co.uk/assets/bolt2/${BOLT_VERSION}/bolt-habitat.min.css`,
      namespace: 'bolt-habitat'
    },
    features: {
      taxonomy: {
        vocabId: 'PROD Habitat Navigation'
      },
      addToTrolley: {
        modal: {
          enabled: true,
          hideExtras: true,
          hideCategories: true
        }
      },
      bestSellers: {
        enabled: false
      },
      sponsoredProducts: {
        enabled: false
      },
      wishlist: {
        enabled: false
      },
      productList: {
        forceClothingTemplate: false,
        forceEnableAltImageHover: false,
        disableComRel: false,
        additionalBrandLogos: null,
        enableSortbyNew: false
      },
      productCard: {
        colorSwatchInline: true,
        colorSwatchAlwaysVisible: false,
        colorSwatchMaxVariations: 4,
        colorSwatchSize: 'small'
      },
      listerTools: {
        hideMobileResultsCount: false,
        offsetSelector: null,
        safeZone: 375,
        reverseScrollBehaviour: false
      },
      categoryList: {
        contentAreaNav: true
      },
      availability: {
        enabled: false
      }
    }
  },
  tu: {
    key: 'tu',
    salesChannel: 'argos',
    canonicalBase: 'https://tuclothing.sainsburys.co.uk',
    faviconPath: '/i/Argos/TuFavicon',
    tealiumPath: 'argos/tu/qa',
    theme: Themes.TuTheme,
    vocab: HabitatVocab,
    bolt: {
      url: `https://www.argos.co.uk/assets/bolt2/${BOLT_VERSION}/bolt-tu.min.css`,
      namespace: 'bolt-tu'
    },
    features: {
      taxonomy: {
        vocabId: 'PROD Tu Navigation'
      },
      addToTrolley: {
        modal: {
          enabled: false,
          hideExtras: false,
          hideCategories: false
        }
      },
      bestSellers: {
        enabled: false
      },
      sponsoredProducts: {
        enabled: false
      },
      wishlist: {
        enabled: false
      },
      productList: {
        forceClothingTemplate: true,
        forceEnableAltImageHover: true,
        disableComRel: true,
        disableTuLogo: true,
        additionalBrandLogos: [
          { name: 'Joules', logoUrl: 'https://media.4rgos.it/i/Argos/joules' },
          {
            name: 'NOISY MAY',
            logoUrl: 'https://media.4rgos.it/i/Argos/NOISY-MAY_fall_winter_2019_original_LOGO_black'
          },
          { name: 'VERO MODA CURVE', logoUrl: 'https://media.4rgos.it/i/Argos/Vero-Moda-Curve_100-black' },
          { name: 'Skechers', logoUrl: 'https://media.4rgos.it/i/Argos/CORP_SKX_BLU-logo' },
          { name: 'Sloggi', logoUrl: 'https://media.4rgos.it/i/Argos/LOGO' },
          { name: 'Hush Puppies', logoUrl: 'https://media.4rgos.it/i/Argos/HP-Logo-Horiz-Large-2019' },
          { name: 'KIDS ONLY', logoUrl: 'https://media.4rgos.it/i/Argos/ONLY KIDS_black' },
          { name: 'ONLY PLAY', logoUrl: 'https://media.4rgos.it/i/Argos/ONLY PLAY_black' },
          { name: 'FIRE AND GLORY', logoUrl: 'https://media.4rgos.it/i/Argos/FG_black_logo_final_1' },
          { name: 'OASIS', logoUrl: 'https://media.4rgos.it/i/Argos/OASIS' },
          { name: 'PIECES', logoUrl: 'https://media.4rgos.it/i/Argos/pieces logo-2020_black' },
          {
            name: 'Caterpillar',
            logoUrl:
              'https://media.4rgos.it/i/Argos/purepng.com-caterpillar-logologobrand-logoiconslogos-2515199391586668y_1'
          },
          { name: 'MAMALICIOUS', logoUrl: 'https://media.4rgos.it/i/Argos/Mamalicious_black_121219' },
          { name: 'VILA', logoUrl: 'https://media.4rgos.it/i/Argos/new-vila-logo' },
          { name: 'Cotswold', logoUrl: 'https://media.4rgos.it/i/Argos/Cotswold-Logo_1' },
          { name: 'FatFace', logoUrl: 'https://media.4rgos.it/i/Argos/FF-Logotype_Grey_RGB_1' },
          { name: 'JUNAROSE', logoUrl: 'https://media.4rgos.it/i/Argos/junarose_black' },
          { name: 'Toezone', logoUrl: 'https://media.4rgos.it/i/Argos/Toezone_1' },
          { name: 'ONLY', logoUrl: 'https://media.4rgos.it/i/Argos/new-only-logo' },
          {
            name: 'Jack and Jones Junior',
            logoUrl: 'https://media.4rgos.it/i/Argos/jackjones_junior_logo_1_line_blue_rgb1'
          },
          { name: 'VERO MODA', logoUrl: 'https://media.4rgos.it/i/Argos/VERO MODA_black' }
        ],
        enableSortbyNew: true
      },
      productCard: {
        colorSwatchInline: false,
        colorSwatchAlwaysVisible: true,
        colorSwatchMaxVariations: 10,
        colorSwatchSize: 'small',
        turnOffCta: true
      },
      listerTools: {
        hideMobileResultsCount: true,
        offsetSelector: '[data-module-name="Header"] header',
        safeZone: 205,
        reverseScrollBehaviour: true
      },
      categoryList: {
        contentAreaNav: false
      },
      availability: {
        enabled: false
      }
    }
  }
}
